import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { SupervisorComponent } from './supervisor.component';
import { MonitorcampanasComponent } from './monitorcampanas/monitorcampanas.component';
import { DiarioComponent } from './diario/diario.component';
import { HorasComponent } from './horas/horas.component';
import { AgentecampanaComponent } from './agentecampana/agentecampana.component';
import { CatalogocampanaComponent } from './catalogocampana/catalogocampana.component';
import { LlamadaprogramadaComponent } from './llamadaprogramada/llamadaprogramada.component';
import { DashboardpivotComponent } from './dashboardpivot/dashboardpivot.component';
import { MonitoragentesComponent } from './monitoragentes/monitoragentes.component';

@NgModule({
  declarations: [
    SupervisorComponent,
    MonitorcampanasComponent,
    DiarioComponent,
    HorasComponent,
    AgentecampanaComponent,
    CatalogocampanaComponent,
    LlamadaprogramadaComponent,
    DashboardpivotComponent,
    MonitoragentesComponent,
  ],
  imports: [
    SharedModule,
    RouterModule,
  ],
  exports: [
    // Export all components so they can be used in /home and /supervisor routes
    SupervisorComponent,
    MonitorcampanasComponent,
    DiarioComponent,
    HorasComponent,
    AgentecampanaComponent,
    CatalogocampanaComponent,
    LlamadaprogramadaComponent,
    DashboardpivotComponent,
    MonitoragentesComponent,
  ]
})
export class SupervisorModule { }
